import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _class, _class2, _descriptor;
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { AbPopup } from "abreact/incubator/ui/popup/AbPopup";
import { PopupUtils } from "abreact/incubator/ui/popup/PopupUtils";
import { AbLocalToolbar, AbLocalToolbarGroup } from "abreact/incubator/ui/toolbar/AbLocalToolbar";
import { AbMarkdownExtensions } from "abreact/input/markdown/AbMarkdownExtensions";
import { AbButton } from "abreact/misc/AbButton";
import { AbSize } from "abreact/misc/AbSize";
import { AbWithTooltip } from "abreact/popup/AbWithTooltip";
import { URLUtils } from "abweb/utils/URLUtils";
import { action, makeObservable, observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";

//
//

/**
 * The component that renders a link for AbMarkdownEditor.
 * Created by the DraftJS Decorator matching an Entity of type "LINK".
 *
 * @deprecated Replace {@link AbMarkdownEditor} with {@link AbMarkdownLexical} markdown editor and its child component AbLinkComponent
 */
export let AbMarkdownLink = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, _dec4 = action.bound, observer(_class = (_class2 = class AbMarkdownLink extends React.Component {
  constructor(abMarkdownLinkProps) {
    super(abMarkdownLinkProps);
    _initializerDefineProperty(this, "showPopupToolbar", _descriptor, this);
    _defineProperty(this, "spanRef", null);
    makeObservable(this);
    this.showPopupToolbar = false;
  }
  onClick(event) {
    this.showPopupToolbar = true;
  }
  jumpToLink(event) {
    this.showPopupToolbar = false;
    const {
      url
    } = this.props.contentState.getEntity(this.props.entityKey).getData();
    window.open(url); // in a new tab
  }
  editLink(event) {
    this.showPopupToolbar = false;
    this.props.containingEditor.editLink();
  }
  deleteLink(event) {
    this.showPopupToolbar = false;
    this.props.containingEditor.deleteLink();
  }
  render() {
    const {
      url
    } = this.props.contentState.getEntity(this.props.entityKey).getData();

    // see if this link renders with an extension
    const protocol = URLUtils.getProtocol(url);
    const extension = protocol ? AbMarkdownExtensions.markdownLinkExtensions.get(protocol) : undefined;

    // Build the toolbar. First, the extra actions come from the appropriate extension
    let extraActions = [];
    if (extension) {
      for (let action of extension.actions) {
        const handler = event => action.onClick(url, this.props.children);
        extraActions.push(/*#__PURE__*/React.createElement(AbButton, {
          key: action.label,
          onClick: handler,
          label: action.label
        }));
      }
    } else {
      // no extension applies, so assume it's a web link, and add "jump".
      extraActions.push(/*#__PURE__*/React.createElement(AbButton, {
        key: "jump",
        onClick: this.jumpToLink,
        label: AbReactResources.markdownEditor_jumpToTarget()
      }));
    }
    let extraActionsToolbarGroup = extraActions.length > 0 ? /*#__PURE__*/React.createElement(AbLocalToolbarGroup, null, extraActions) : null;

    // Put the extra actions into a toolbar, and put that into a popup.
    const popupToolbar = /*#__PURE__*/React.createElement(AbPopup, {
      className: "ab-markdown-popup-toolbar",
      origin: this.spanRef || undefined,
      positioner: PopupUtils.VERTICAL_FIXED_SIZE_POSITIONER,
      overlay: false,
      flushContent: true,
      onClose: action(() => this.showPopupToolbar = false),
      onBackgroundCaptureMouseDown: action(() => {
        this.showPopupToolbar = false;
      })
    }, /*#__PURE__*/React.createElement(AbLocalToolbar, {
      type: "stand-alone"
    }, /*#__PURE__*/React.createElement(AbLocalToolbarGroup, null, /*#__PURE__*/React.createElement(AbButton, {
      onClick: this.editLink,
      label: AbReactResources.markdownEditor_editLink(),
      size: AbSize.SMALL
    }), /*#__PURE__*/React.createElement(AbButton, {
      onClick: this.deleteLink,
      label: AbReactResources.markdownEditor_deleteLink(),
      size: AbSize.SMALL
    })), extraActionsToolbarGroup));

    // Render the link.  If we have an extension, use its "readOnly" render() method.  Otherwise, it's just a span with a class.
    const span = /*#__PURE__*/React.createElement("span", {
      className: "ab-markdown-link",
      onClick: this.onClick,
      ref: x => this.spanRef = x
    }, extension && extension.render({
      url
    }, this.props.children), !extension && this.props.children, this.showPopupToolbar && popupToolbar);
    return extension ? span : /*#__PURE__*/React.createElement(AbWithTooltip, {
      tooltip: url
    }, span);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showPopupToolbar", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "onClick", [_dec], Object.getOwnPropertyDescriptor(_class2.prototype, "onClick"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "jumpToLink", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "jumpToLink"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "editLink", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "editLink"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "deleteLink", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "deleteLink"), _class2.prototype), _class2)) || _class);
//# sourceMappingURL=AbMarkdownLink.js.map
